@if (
    optionListService.depositAvailable() &&
    !dataService.error() &&
    !optionListService.isDataLoading() &&
    !depositService.isDataLoading() &&
    !userDataService.isDataLoading()
) {
    @if (isGvcBetslip()) {
        <app-gvc-betslip />
    } @else {
        <app-lcg-betslip />
    }
}
